import React, { Fragment } from "react";
import CountdownComponent from "./CountdownData";
import { Container } from "reactstrap";
import comingsoon from "../../assets/images/other-images/coming-soon-bg.jpg";
import authVideo from "../../assets/video/auth-bg.mp4";
import { Link } from "react-router-dom";
const ComingsoonVideo = (props) => {
  return (
    <Fragment>
      <div className="page-wrapper">
        {/* <!-- Page Body Start--> */}
        <Container fluid={true} className="p-0">
          <div className="comingsoon auth-bg-video">
            <video
              id="bgvid"
              poster={comingsoon}
              playsInline=""
              autoPlay={true}
              muted=""
              loop=""
            >
              <source src={authVideo} type="video/mp4" />
            </video>
            <div className="comingsoon-inner text-center">
              <Link to={`${process.env.REACT_APP_PUBLIC_URL}/dashboard/default`}>
                <img src={require("../../assets/images/logo/logo_old.png")} alt="" />
              </Link>
              <h5>WE ARE COMING SOON</h5>
              <div className="countdown" id="clockdiv">
                <CountdownComponent />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Fragment>
  );
};

export default ComingsoonVideo;
